/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QaOperatorModel { 
    operatorName?: string;
    analyzedCalls?: number;
    avgScore?: number;
    clientRating?: number;
    negativeSentimentPercent?: number;
    flaggedCount?: number;
}

